<template>
  <path
    id="ic_undo_24px"
    d="M23.17,9.016A21.1,21.1,0,0,0,9.258,14.258L2,7V25.145H20.146l-7.3-7.3a16.071,16.071,0,0,1,25.646,7.3l4.778-1.573A21.2,21.2,0,0,0,23.17,9.016Z"
    transform="translate(-2 -7)" />
</template>
